import { Box, type BoxProps, WarningIcon } from "@hightouch/htui";

export const OVERDUE_LABEL = "Overdue";

/** Marks a past-due date by shape as well as by the danger color. */
export const OverdueIcon = (props: BoxProps) => (
  <Box
    as={WarningIcon}
    role="img"
    aria-label={OVERDUE_LABEL}
    boxSize={3.5}
    flexShrink={0}
    color="danger.base"
    {...props}
  />
);
